var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import { Component, Prop, Watch } from 'vue-property-decorator';
var BaseModalMixin = /** @class */ (function (_super) {
    __extends(BaseModalMixin, _super);
    function BaseModalMixin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BaseModalMixin.prototype.data = function () {
        return {
            show: this.visible
        };
    };
    BaseModalMixin.prototype.mounted = function () {
        var _this = this;
        this.$root.$on('open-modal', function (id) {
            if (_this.id === id) {
                _this.active();
            }
        });
        this.$root.$on('close-modal', function (id) {
            if (_this.id === id) {
                _this.deactivate();
            }
        });
    };
    BaseModalMixin.prototype.beforeEnter = function () {
        this.$emit('open');
    };
    BaseModalMixin.prototype.afterEnter = function () {
        this.$emit('opened');
    };
    BaseModalMixin.prototype.beforeLeave = function () {
        this.$emit('before-close');
    };
    BaseModalMixin.prototype.afterLeave = function () {
        this.$emit('close');
    };
    BaseModalMixin.prototype.active = function () {
        this.show = true;
        /*
         * This is not the best practice but be my quest and improve it. This prevents from page scroll when
         * modal is active.
         */
        document.querySelector('html').classList.add('is-clipped');
    };
    BaseModalMixin.prototype.deactivate = function () {
        if (this.closable) {
            document.querySelector('html').classList.remove('is-clipped');
            this.show = false;
        }
    };
    BaseModalMixin.prototype.onVisibleChanged = function (value, oldValue) {
        this.show = value;
    };
    __decorate([
        Prop({ type: String })
    ], BaseModalMixin.prototype, "id", void 0);
    __decorate([
        Prop({ type: Boolean })
    ], BaseModalMixin.prototype, "visible", void 0);
    __decorate([
        Prop({ type: Boolean })
    ], BaseModalMixin.prototype, "closable", void 0);
    __decorate([
        Watch('visible')
    ], BaseModalMixin.prototype, "onVisibleChanged", null);
    BaseModalMixin = __decorate([
        Component({})
    ], BaseModalMixin);
    return BaseModalMixin;
}(Vue));
export default BaseModalMixin;
